import { HTTPService } from './httpService';
import { Auth } from 'aws-amplify';

const http = new HTTPService();

export class OBDAPI {

  /**
   * Get available conversation starter chips
   * @param {number} installerId
   * @returns {Promise<{chips: Array}>}
   */
  static async getChips(installerId, locationId) {
    const params = { installerId };
    if (locationId) params.locationId = locationId;
    const response = await http.get('/api/obd/chips', params);
    return response.data;
  }

  /**
   * Send a chat message (non-streaming fallback)
   * @param {string} message
   * @param {string} sessionId
   * @param {number} installerId
   * @returns {Promise<{message: string, sessionId: string}>}
   */
  static async sendMessage(message, sessionId, installerId, locationId) {
    const response = await http.post('/api/obd/chat', { message, sessionId, installerId, locationId: locationId || null });
    return response.data;
  }

  /**
   * Get the streaming endpoint URL with auth token for fetch-based SSE.
   * We use raw fetch (not axios) for streaming — need the full URL + token.
   * @returns {Promise<{url: string, token: string}>}
   */
  static async getStreamConfig() {
    const user = await Auth.currentAuthenticatedUser();
    const token = user.signInUserSession.accessToken.jwtToken;
    const url = `${process.env.REACT_APP_API_URL}/api/obd/stream`;
    return { url, token };
  }

  /**
   * Health check
   * @returns {Promise<any>}
   */
  static async healthCheck() {
    const response = await http.get('/api/obd/health');
    return response.data;
  }
}
